module.exports = "/_next/static/images/unknown-3932a777bd7399ec5b714a774b32b3e8.svg";